<template>
  <div>
    <div v-if="file">
      <p class="has-text-right">
        <i class="fas fa-file-pdf fa-2x mr-1"></i>
        <span class="mb-1 inline-block mr-1">{{ file }}</span>
        <button class="button is-warning" @click="() => updateFileData('')">
          Change File
        </button>
      </p>
    </div>
    <div class="file is-right" v-else>
      <label class="file-label">
        <input
          @change="e => uploadFile(e.target)"
          class="file-input"
          type="file"
          name="resume"
        />
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-upload"></i>
          </span>
          <span class="file-label">
            Choose a file…
          </span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFile",
  props: {
    file: { type: String, default: () => "" }
  },
  methods: {
    uploadFile(e) {
      console.log(e.files);
      if (e.files) {
        const formData = new FormData();
        formData.append("files", e.files[0]);
        axios
          .post(process.env.VUE_APP_SERVER + "upload/", formData)
          .then(res => {
            if (res.data.message.indexOf("Success") > -1) {
              this.updateFileData(e.files[0].name);
            }
          })
          .catch(error => {
            console.error(error);
            this.$noty.error("There was a problem uploading your file.");
          });
      } else {
        this.$noty.warning("No file selected.");
      }
    },
    updateFileData(value) {
      this.$emit("updateFile", value);
    }
  }
};
</script>
